export const versionCollector = [
  { value: '101', label: 'V1EQSTM' },
  { value: '102', label: 'V1EQSTMDY' },
  { value: '103', label: 'V1EQSTP' },
  { value: '104', label: 'V1EQSTPDY' },
  { value: '105', label: 'V1AM22' },
  { value: '106', label: 'V1AM22DY' },
  { value: '107', label: 'V1AM22BZ' },
  { value: '108', label: 'V1AM22DYBZ' },
  { value: '109', label: 'V1AM7021' },
  { value: '110', label: 'V1AM7021DY' },
  { value: '201', label: 'V2EQDYGSM' },
  { value: '202', label: 'V2AMDYGSM' },
];
export default {
  versionCollector,
};
